module.exports = __webpack_public_path__ + "img/ImgC2.02d1d394.jpeg";